window.theme = window.theme || {}
theme.updateCart = function () {
  $('body').addClass('cart-drawer-opened');

  fetch('/?view=cart')
    .then(response => response.text())
    .then(cartData => {
      $('.cart-simple-drawer__form-wrapper').html('').append(cartData);

      // This code is use to parse json object. for cart count
      var el = document.createElement('div');
      el.innerHTML = cartData;
      var template_json_data = JSON.parse(el.querySelector('[data-options]').innerHTML);
      $('.cart-simple__count').text(template_json_data.item_count);

      var total_price = template_json_data.cart_total / 100;
      $('.cart-simple__total').text('$' + total_price.toFixed(2) + ' USD');

      setTimeout(() => {
        $('#cart-simple-drawer').addClass('loaded');
      }, 500);
    })
}

theme.updateQuantity = function (line, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      quantity: qty,
      line: line
    })
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    theme.updateCart();
  })["catch"](function (error) {
    console.error('Error:', error);
  });
}

jQuery(document).ready(function ($) {
  $('.custom-header-cart').on('click', function (event) {
    event.preventDefault();

    theme.updateCart();
    $('body').addClass('cart-drawer-opened');
  });

  $('.close-drawer').on('click', function (event) {
    $('body').removeClass('cart-drawer-opened');
    $('#cart-simple-drawer').removeClass('loaded');
  });

  $(document).on('click', 'cart-remove-button', function (event) {
    //event.preventDefault();
    $('#cart-simple-drawer').removeClass('loaded');
    $('body').addClass('cart-drawer-opened');
    setTimeout(function() {
      theme.updateCart()
    }, 500);
  });
});